import { useAppDispatch } from '@hooks/redux'
import { useEffect } from 'react'
import {
  clearBacklink,
  setActiveSection,
  setBackLink,
} from '@redux/site/siteSlice'
import { Tabs } from '@components/Tabs/Tabs'
import { Outlet } from 'react-router-dom'
import { RoutePaths } from '@interfaces/routePaths'

export const Location = () => {
  const dispatch = useAppDispatch()

  useEffect(() => {
    dispatch(
      setBackLink({
        title: 'location list',
        href: `${RoutePaths.ADMIN_SETTINGS}/${RoutePaths.ADMIN_SETTINGS_LOCATION_LIST}`,
      }),
    )

    return () => {
      dispatch(clearBacklink())
    }
  })

  return (
    <>
      <Tabs
        data={[
          {
            label: 'Public profile',
            path: `${RoutePaths.ADMIN_SETTINGS}/${RoutePaths.ADMIN_SETTINGS_LOCATION}/${RoutePaths.ADMIN_SETTINGS_LOCATION_PUBLIC_PROFILE}`,
          },
          {
            label: 'Auto-tagging',
            path: `${RoutePaths.ADMIN_SETTINGS}/${RoutePaths.ADMIN_SETTINGS_LOCATION}/${RoutePaths.ADMIN_SETTINGS_LOCATION_AUTO_TAGGING}`,
          },
          {
            label: 'Highlight tags',
            path: `${RoutePaths.ADMIN_SETTINGS}/${RoutePaths.ADMIN_SETTINGS_LOCATION}/${RoutePaths.ADMIN_SETTINGS_LOCATION_HIGHLIGHTED_TAGS}`,
          },
          {
            label: 'Custom Fields',
            path: `${RoutePaths.ADMIN_SETTINGS}/${RoutePaths.ADMIN_SETTINGS_LOCATION}/${RoutePaths.ADMIN_SETTINGS_LOCATION_CUSTOM_FIELDS}`,
          },
        ]}
      />
      <Outlet />
    </>
  )
}
